// false: guests only. true: also show to logged-in/registered users.
export const SHOW_BANNER_TO_LOGGED_IN_USERS = false;
